// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"CaptureVisa_style_b-icon-warning__APRyA","wrapper":"CaptureVisa_style_wrapper__Lq1UQ","rotate":"CaptureVisa_style_rotate__9w3D1"};